import PropTypes from 'prop-types'
import NotificationBadgeImage from 'src/assets/img/common/noti_badge.svg'

const NotificationBadge = ({ className = 'top-0.5 right-1', style }) => {
  return (
    <img
      className={`w-7 h-7 rounded-full absolute ${className}`}
      style={style}
      src={NotificationBadgeImage}
    />
  )
}

NotificationBadge.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default NotificationBadge
